import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type StopButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const StopButton = ({
    label = "Stop",
    loadingText = "Stopping...",
    buttonType = "button",
    variant = "destructive-secondary",
    ...props
}: StopButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="stop"
            testId="stop-button"
            buttonType={buttonType}
            variant={variant}
            {...props}
        />
    );
};

export default StopButton;
